/**
 * 背景层（原站 Lt 组件 / ueMMDx）。
 *
 * 行为（实测自 bundle）：
 *  - 挂载后立即把两条环的 strokeDashoffset 从 630 动画到 0，1600ms，easeOutCubic
 *  - 加上 active 类；随后每 30000ms 让两条环交换 begin / end，触发 29.5s 的位移过渡
 *  - 4 个呼吸圆没有任何 JS，纯 CSS 动画（kfBreath 2.4s）
 */
import { useEffect, useRef, useState } from 'react';
import './quest.css';

const RING_PATH = 'M 100, 100 m 0, -100 a 100,100 0 1,0 0,200 a 100,100 0 1,0 0,-200';
/** 两条环交换 begin/end 的间隔 */
const SWAP_INTERVAL = 30_000;

function Ring({
  stroke,
  width,
  mirrored,
  phase,
}: {
  stroke?: string;
  width: number;
  mirrored?: boolean;
  phase: 'begin' | 'end';
}) {
  return (
    <div className={[mirrored ? 'cycle cycle1' : 'cycle cycle2', phase].join(' ')}>
      <svg viewBox="-2 -2 204 204">
        <path
          className="drawNow"
          fill="none"
          stroke={stroke}
          strokeWidth={width}
          strokeDasharray={630}
          strokeDashoffset={630}
          d={RING_PATH}
        />
      </svg>
    </div>
  );
}

export function QuestBackground({ active }: { active: boolean }) {
  const [phase, setPhase] = useState<'begin' | 'end'>('begin');
  const timer = useRef<number | null>(null);

  useEffect(() => {
    if (!active) {
      if (timer.current !== null) window.clearInterval(timer.current);
      timer.current = null;
      return;
    }
    timer.current = window.setInterval(() => {
      setPhase((p) => (p === 'begin' ? 'end' : 'begin'));
    }, SWAP_INTERVAL);
    return () => {
      if (timer.current !== null) window.clearInterval(timer.current);
    };
  }, [active]);

  return (
    <div className={active ? 'background active' : 'background'}>
      <Ring width={0.2} mirrored phase={phase} />
      <Ring stroke="#202020" width={0.3} phase={phase} />
      <div className="backgroundMovement">
        <div className="round" />
        <div className="round" />
        <div className="round" />
        <div className="round" />
      </div>
    </div>
  );
}
